import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import { useLang } from "hooks";
import Completion from "icons/completion";

import { NotPersistAction } from "store/actions";
import { setSplitedItems } from "store/checkout/order/orderSlice";
import { setIsSplitted, clearSplit } from "store/checkout/cart/cartSlice";

import { PageHeaderV2 } from "components/PageHeader";
import GoogleReview from "components/google-reviews";
import { CustomButton } from "components/Button";
import { TranslationText } from "components/TextTranslationContainer";

import useDineIn from "../hooks/useDineIn";

function Payment() {
  const { goToLogin, goToSettings, goBack } = useDineIn();
  const dispatch = useDispatch();


  const { currentLang } = useLang();
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);

  const handleGoBack = () => {
    dispatch(NotPersistAction.toggleOrderPlaceModel(false));
    goBack();
  };

  const share = () => {
    dispatch(NotPersistAction.toggleOrderPlaceModel(false));
    const message = `Hi, I have just ordered from ${brandInfo?.brand?.brandName} You can also avail BIG discounts as soon as you place your first order. ${brandInfo?.storeFrontURL } `;
    window.open(`https://wa.me/?text=${message}`, "_blank");
  };

  useEffect(() => {
    dispatch(clearSplit());
    dispatch(setSplitedItems([]));
    dispatch(setIsSplitted(false));
  }, []);

  return (
    <div
      className={`flex flex-col gap-8 items-center${
        currentLang === "AR" ? "border-sc-l" : "border-sc"
      }`}
    >
      <PageHeaderV2
        pageTitle={"Payment Complete"}
        authClick={goToLogin}
        userClick={goToSettings}
        onGoBack={handleGoBack}
        containerStyleProps={{
          style: {
            position: "relative",
          },
        }}
        headerStyleProps={{
          className: "p-5",
        }}
      />

      <div className="flex-1 flex flex-col gap-2 justify-center items-center cursor-pointer">
        <Completion />
        <h1 className="text-black font-medium leading-normal mt-6 text-center text-24x">
          {t("Thanks, Friend!")}
          <br />
          {t("Your payment has been completed")}
        </h1>
         <GoogleReview /> 
      </div>
      <div className="w-full bg-dark-blue-100 p-6 flex flex-col gap-2">
        {brandInfo?.storeFrontURL && (
          <CustomButton outline onClick={share}>
            <TranslationText text={"Share with Friends"} />
          </CustomButton>
        )}
      </div>
    </div>
  );
}
export default Payment;
